import { render } from "./ReferencesTable.vue?vue&type=template&id=7ec29fdd&scoped=true"
import script from "./ReferencesTable.vue?vue&type=script&lang=js"
export * from "./ReferencesTable.vue?vue&type=script&lang=js"

import "./ReferencesTable.vue?vue&type=style&index=0&id=7ec29fdd&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec29fdd"]])

export default __exports__